import type { InvoiceLineItemResponseDto } from '@trellis/api'
import { Tooltip, TooltipContent, TooltipTrigger } from '@trellis/roots/tooltip'
import { AlertCircle } from 'lucide-react'

const CHANGED_FIELD_LABELS: Record<string, string> = {
  title: 'title',
  description: 'description',
  unitPrice: 'price',
  unitType: 'unit',
  taxable: 'tax status',
}

function formatChangedFieldsMessage(changedFields: string[]): string {
  const labels = changedFields.map((field) => CHANGED_FIELD_LABELS[field] ?? field)
  const joined =
    labels.length <= 1
      ? (labels[0] ?? '')
      : `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
  const verb = labels.length > 1 ? 'have' : 'has'
  const sentence = `${joined.charAt(0).toUpperCase()}${joined.slice(1)} ${verb} changed in the registry since this invoice was sent.`
  return sentence
}

export interface LineItemDriftIndicatorProps {
  changedFields: InvoiceLineItemResponseDto['changedFields']
}

export function LineItemDriftIndicator({ changedFields }: LineItemDriftIndicatorProps) {
  if (changedFields.length === 0) return null

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="text-amber-600 hover:text-amber-700"
          aria-label="Registry item has changed"
        >
          <AlertCircle className="size-3.5 shrink-0" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent>{formatChangedFieldsMessage(changedFields)}</TooltipContent>
    </Tooltip>
  )
}
